import {Component, HostListener, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {FooterComponent} from "../../site/component/footer/footer.component";
import {MenuBarComponent} from "../../site/component/menu-bar/menu-bar.component";
import {PerformanceSectionComponent} from "../../site/component/performance-section/performance-section.component";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {TopBarComponent} from "../../site/component/top-bar/top-bar.component";
import {slideInAnimation} from "../../route-animation";
import {Meta} from "@angular/platform-browser";
import {ConfirmationService, MessageService} from "primeng/api";
import {AdminSideMenuComponent} from "../admin-side-menu/admin-side-menu.component";
import {min} from "rxjs";
import {DecimalPipe, NgIf} from "@angular/common";
import {RestBackendService} from "../../services/rest-backend.service";
import {GlobalService} from "../../services/global.service";
import {FileUploadModule} from "primeng/fileupload";
import {ToastModule} from "primeng/toast";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {ConfigService} from "../../services/config.service";
import {AdminUser} from "../../dto/AdminUser";

@Component({
    selector: 'app-admin-template',
    standalone: true,
    imports: [
        FooterComponent,
        MenuBarComponent,
        PerformanceSectionComponent,
        RouterOutlet,
        TopBarComponent,
        AdminSideMenuComponent,
        NgIf,
        FileUploadModule,
        ToastModule,
        ConfirmDialogModule
    ],
    templateUrl: './admin-template.component.html',
    styleUrl: './admin-template.component.css',
    animations: [
        slideInAnimation
    ]
})
export class AdminTemplateComponent implements OnInit{

    static width: number;
    sidbarStyle: boolean = true;
    minimiz: boolean = false;

    constructor( public restBack: RestBackendService,public route: Router,
                 private metaService: Meta,
                 public global: GlobalService,
                 protected  config: ConfigService,
                 public activeRoute: ActivatedRoute,
                 protected messageService: MessageService,
                 protected confirmationService: ConfirmationService,
                 @Inject(LOCALE_ID) public locale: string
    ) {
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode;
        if (keyPressed === 119) {
            debugger;
        }
    }

    ngAfterContentInit(): void {

        document.body.onscroll = function( event ) {
            let navbar = document.getElementById("header");
            let sticky = navbar.offsetTop;
            // @ts-ignore
            if (event.target.scrollTop> sticky) {
                navbar.classList.add("sticky-header")
            }
            else {
                navbar.classList.remove("sticky-header");
            }

        };
    }

    ngOnInit(): void {

    }


    //......................................................................

    @HostListener('window:scroll', [])
    onWindowScroll() {

    }

    @HostListener('window:touchStart', ['$event']) checkTouchEnd(event) {
        let start = event.changedTouches[0];
    }

    getDirection(): string {
        if (this.locale == "fa") {
            return "rtl";
        } else {
            return "ltr";
        }
    }
    responsiveCloseMenu() {
        if (AdminTemplateComponent.width < 800) {
            this.sidbarStyle = false;
        }
    }

    toggelSideMenu(side: HTMLDivElement, center: HTMLDivElement, sidetop: HTMLElement) {
        if (side.classList.contains("min")) {
            side.classList.remove("min");
            center.classList.remove("min");
            if(this.getDirection()=="rtl"){
                sidetop.classList.remove("pi-angle-double-left");
                sidetop.classList.add("pi-angle-double-right");
            }else{
                sidetop.classList.remove("pi-angle-double-right");
                sidetop.classList.add("pi-angle-double-left");
            }
            this.minimiz=false;
        }else {
            side.classList.add("min");
            center.classList.add("min");
            if(this.getDirection()=="rtl"){
                sidetop.classList.remove("pi-angle-double-right");
                sidetop.classList.add("pi-angle-double-left");
            }else{
                sidetop.classList.remove("pi-angle-double-left");
                sidetop.classList.add("pi-angle-double-right");
            }
            this.minimiz=true;
        }


    }

    checkLogin() {
        // this.global.displayCreateApp = true;
        var observable = this.restBack.doGet("lnd/user/check_login");
        observable.subscribe((result: String) => {
            var status = result["status"];

            if (status == 200) {

            } else if (status == 401) {
                this.gotoLogin();
            } else if (status == 1017) {

            }
        });
    }
    gotoLogin() {
        console.log((new Error()).stack);
        localStorage.removeItem("user");
        this.route.navigate(['admin']).then(() => {
            window.location.reload();
        });

    }

    farsitableTemplate(first, totalRec): string {
        let decimal: DecimalPipe = new DecimalPipe(this.locale);
        var total = decimal.transform(totalRec);
        var t = $localize`:@@Showing Total Rec:Showing $first to $last of $totalRecords entries`;
        t = t.replace("first$", (totalRec > 0 ? first + 1 : 0))
            .replace("last$", (first + 10 <= totalRec ? first + 10 : totalRec) + "").replace("totalRecords$", total);
        return t;
    };

    logout() {
        var observable = this.restBack.doGet("lnd/user/logout"  );
        observable.subscribe((result: any) => {
            var status = result["status"];
            if (status == 200) {
                this.route.navigate(["/admin"]);
            }else if(status == 401) {
                // this.messageService.clear();
                // this.messageService.add({
                //     severity: 'error',
                //     summary:$localize`:@@login:login`,
                //     detail:$localize`:@@The username or password is incorrect:The username or password is incorrect`
                // });
            }
        });
    }
}
